export const AllPurchaseRequisitionsReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_ALL_PURCHASE_REQUISITIONS_REQUEST":
      return {
        loading: true,
      };
    case "GET_ALL_PURCHASE_REQUISITIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        requisitions: action.payload.purchaseRequisitions,
        requisitionCount: action.payload.purchaseRequisitionsCount,
      };
    case "GET_ALL_PURCHASE_REQUISITIONS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const CurrentUserPurchaseRequisitionsReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_CURRENT_USER_PURCHASE_REQUISITIONS_REQUEST":
      return {
        loading: true,
      };
    case "GET_CURRENT_USER_PURCHASE_REQUISITIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        requisitions: action.payload.purchaseRequisitions,
        requisitionCount: action.payload.purchaseRequisitionsCount,
      };
    case "GET_CURRENT_USER_PURCHASE_REQUISITIONS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const CreatePurchaseRequisitionReducer = (
  state = { requisition: {} },
  action
) => {
  switch (action.type) {
    case "CREATE_PURCHASE_REQUISITION_REQUEST":
      return {
        loading: true,
        error: null,
        success: false,
      };
    case "CREATE_PURCHASE_REQUISITION_SUCCESS":
      return {
        loading: false,
        success: action.payload.success,
        requisition: action.payload,
      };
    case "CREATE_PURCHASE_REQUISITION_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CREATE_PURCHASE_REQUISITION_RESET":
      return {
        ...state,
        success: false,
      };

    case "CLEAR_ERRORS":
      return {
        error: null,
      };
    default:
      return state;
  }
};

export const PurchaseRequisitionDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_PURCHASE_REQUISITION_DETAIL_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_PURCHASE_REQUISITION_DETAIL_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        requisition: action.payload,
      };
    case "GET_PURCHASE_REQUISITION_DETAIL_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const PurchaseRequisitionDeleteReducer = (state = [], action) => {
  switch (action.type) {
    case "DELETE_PURCHASE_REQUISITION_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "DELETE_PURCHASE_REQUISITION_SUCCESS":
      return {
        ...state,
        loading: false,
        deleted: action.payload,
      };
    case "DELETE_PURCHASE_REQUISITION_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "DELETE_PURCHASE_REQUISITION_RESET":
      return {
        ...state,
        deleted: {},
      };

    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const UpdatePurchaseRequisitionStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_PURCHASE_REQUISITION_STATUS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_PURCHASE_REQUISITION_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        updated: action.payload,
      };
    case "UPDATE_PURCHASE_REQUISITION_STATUS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "UPDATE_PURCHASE_REQUISITION_STATUS_RESET":
      return {
        ...state,
        success: false,
        updated: {},
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const SendPurchaseRequisitionCommentReducer = (state = {}, action) => {
  switch (action.type) {
    case "SEND_PURCHASE_REQUISITION_COMMENT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "SEND_PURCHASE_REQUISITION_COMMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        comment: action.payload,
      };
    case "SEND_PURCHASE_REQUISITION_COMMENT_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "SEND_PURCHASE_REQUISITION_COMMENT_RESET":
      return {
        ...state,
        success: false,
        comment: {},
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
